/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c12d95165f8470e00db04cc23134d9a956bd27d2";
